import axios from 'axios';

const baseURL =
  (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/+$/, '');

function getAuthHeader(forceNoAuth = false) {
  if (forceNoAuth) return {};
  const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const API = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

export async function adminLogin(username: string, password: string) {
  const res = await API.post('/admin/login', { username, password });
  if (res.data?.token) {
    sessionStorage.setItem('authToken', res.data.token);
  }
  return res.data;
}

export async function adminRegister(username: string, password: string) {
  const res = await API.post('/admin/register', { username, password });
  return res.data;
}

export async function forgotPassword(email: string) {
  const res = await API.post('/admin/forgot-password', { email });
  return res.data;
}

export async function adminUpdatePassword(oldPassword: string, newPassword: string) {
  const res = await API.put('/admin/password', { oldPassword, newPassword }, { headers: getAuthHeader() });
  return res.data;
}

export async function getCurriculo(cpf: string) {
  return (await API.get(`/curriculo/${cpf}`, { headers: getAuthHeader() })).data;
}

export async function saveCurriculo(payload: { cpf: string; data: any }) {
  // No modo anônimo, não envia Authorization
  const anon = sessionStorage.getItem('anon') === '1';
  return (await API.post('/curriculo', payload, { headers: getAuthHeader(anon) })).data;
}

export async function improveText(text: string, fieldKey?: string, context?: any) {
  // No modo anônimo, não envia Authorization
  const anon = sessionStorage.getItem('anon') === '1';
  return (await API.post(
    '/curriculo/improve-text',
    { text, fieldKey, context },
    { headers: getAuthHeader(anon) }
  )).data;
}

export async function generatePdf(cpf: string, data: any) {
  // No modo anônimo, não envia Authorization
  const anon = sessionStorage.getItem('anon') === '1';
  const res = await API.post(
    `/curriculo/${cpf}/pdf`,
    { data },
    { responseType: 'blob', headers: getAuthHeader(anon) }
  );
  return res.data;
}

export async function fixFormatting(data: any) {
  // No modo anônimo, não envia Authorization
  const anon = sessionStorage.getItem('anon') === '1';
  return (await API.post(
    '/curriculo/fix-formatting',
    { data },
    { headers: getAuthHeader(anon), timeout: 60000 }
  )).data;
}

export async function getAllCurriculos() {
  return (await API.get('/admin/curriculos', { headers: getAuthHeader() })).data;
}
